/**
 * This tells if the app in running in browser or server-side-rendering.
 * @see https://github.com/reactivestack/cookies/issues/295
 */
export const isHopefullyDomEnvironment = (): boolean =>
  typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined';
